import { Search, Headphones, Heart } from "lucide-react";

const steps = [
  { icon: Search, title: "Explora", desc: "Navega por nuestro catálogo de clásicos cristianos organizados por categoría y autor." },
  { icon: Headphones, title: "Escucha o lee", desc: "Reproduce audiolibros con narración profesional o descarga el PDF completo." },
  { icon: Heart, title: "Crece", desc: "Profundiza en tu fe con contenido que transforma. Retoma donde lo dejaste." },
];

export function HowItWorks() {
  return (
    <section id="how-it-works" className="py-24 bg-section-alt">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-foreground mb-4">
          Cómo funciona
        </h2>
        <p className="text-center text-muted-foreground mb-16 max-w-lg mx-auto">
          En tres simples pasos, comienza tu viaje espiritual.
        </p>

        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          {steps.map((s, i) => (
            <div key={i} className="text-center group">
              <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-5 group-hover:bg-primary/20 transition-colors">
                <s.icon className="h-7 w-7 text-primary" />
              </div>
              <div className="text-sm font-body font-semibold text-accent-gold mb-2">Paso {i + 1}</div>
              <h3 className="text-xl font-heading font-bold text-foreground mb-2">{s.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
